import { mutatorAction } from "satcheljs";
import { SchedulesViewStateStore } from "sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";
import schedulesViewStateStore from "../store/store";

/**
 * Updates the data in date range (shifts and notes) loaded state
 */
export default mutatorAction("UPDATE_IS_DATA_IN_DATE_RANGE_LOADED",
    function updateIsDataInDateRangeLoaded(
        isDataInDateRangeLoaded: boolean,
        viewState?: SchedulesViewStateStore | IPreviewSchedulePageStore
    ) {
        (viewState ? viewState : schedulesViewStateStore()).isDataInDateRangeLoaded = isDataInDateRangeLoaded;
    }
);